function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#F8F8F8;}\n\t.st1{opacity:0.7;}\n\t.st2{fill:#141416;}\n\t.st3{fill:#F6CE31;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.7679 -0.6406 0.6406 0.7679 -18.7505 15.6876)",
  className: "st0",
  cx: 12.3,
  cy: 33.7,
  rx: 8.7,
  ry: 4.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.6,40.4c-1.7,0.3-3.2,0-4.1-1c-0.8-1-0.9-2.6-0.2-4.3C6,33.3,7.3,31.5,9.1,30c1.8-1.5,3.8-2.5,5.7-2.9 c1.9-0.4,3.4,0,4.2,1c0.8,1,0.9,2.6,0.2,4.3c-0.7,1.8-2.1,3.6-3.9,5.1C13.5,39.1,11.4,40.1,9.6,40.4z M15,27.3c-0.1,0-0.1,0-0.2,0 c-1.8,0.4-3.8,1.4-5.6,2.8c-1.8,1.5-3.1,3.2-3.8,5c-0.7,1.7-0.6,3.2,0.2,4.1c1.7,2,6,1.1,9.6-1.9c1.8-1.5,3.1-3.2,3.8-5 c0.7-1.7,0.6-3.2-0.2-4.1C18.1,27.3,16.7,27,15,27.3z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.8363 -0.5482 0.5482 0.8363 -15.8976 10.3232)",
  className: "st0",
  cx: 9.3,
  cy: 31.8,
  rx: 10.4,
  ry: 5.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.2,39.1c-0.3,0-0.6,0.1-0.8,0.1c-2.3,0.2-4-0.4-4.8-1.6c-0.8-1.3-0.7-3.1,0.4-5.1c1.1-2,3-3.9,5.3-5.4 c2.3-1.5,4.9-2.5,7.1-2.7c2.3-0.2,4,0.4,4.8,1.6s0.7,3.1-0.4,5.1c-1.1,2-3,3.9-5.3,5.4C10.4,37.8,8.2,38.7,6.2,39.1z M12.6,24.8 c-2,0.3-4.1,1.2-6.1,2.6c-2.3,1.5-4.2,3.4-5.2,5.3c-1.1,1.9-1.2,3.6-0.4,4.8l0,0c0.8,1.2,2.4,1.7,4.5,1.5c2.2-0.2,4.7-1.2,7-2.7 c2.3-1.5,4.2-3.4,5.2-5.3c1.1-1.9,1.2-3.6,0.4-4.8c-0.8-1.2-2.4-1.7-4.5-1.5C13.1,24.7,12.8,24.7,12.6,24.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.7912 -0.6115 0.6115 0.7912 0.3832 24.4663)",
  className: "st0",
  cx: 36,
  cy: 11.7,
  rx: 8.7,
  ry: 4.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.4,18.2c0,0-0.1,0-0.1,0c-1.9,0.3-3.4-0.1-4.2-1.2c-0.8-1-0.8-2.6-0.1-4.3c0.8-1.7,2.2-3.5,4-4.9c3.8-3,8.3-3.6,10-1.5 l0,0c1.7,2.1-0.1,6.3-4,9.3C37.2,16.9,35.2,17.9,33.4,18.2z M38.7,5.4C37,5.7,35,6.5,33.2,8c-1.8,1.4-3.2,3.1-4,4.8 c-0.7,1.7-0.7,3.1,0,4.1c0.8,1,2.2,1.4,4,1.1c1.8-0.3,3.8-1.2,5.7-2.6c3.7-2.9,5.5-6.9,3.9-9l0,0C42,5.4,40.5,5,38.7,5.4z"
})), /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.7158 -0.6983 0.6983 0.7158 4.0217 26.6568)",
  className: "st0",
  cx: 34.8,
  cy: 8.4,
  rx: 10.4,
  ry: 5.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.2,16.7c-1.7,0.3-3.1,0-4-0.9c-2.2-2.2-0.5-7.3,3.6-11.4c2-2,4.3-3.4,6.4-4c2.2-0.6,4-0.4,5,0.7c1.1,1.1,1.3,2.9,0.6,5 c-0.7,2.1-2.2,4.4-4.2,6.3C36.3,14.8,33.5,16.3,31.2,16.7z M38.4,0.4c-0.3,0.1-0.7,0.1-1,0.2c-2.1,0.6-4.4,2-6.3,4 c-4.1,4-5.7,8.9-3.6,11c2.1,2.1,7,0.6,11.1-3.3c2-1.9,3.4-4.1,4.1-6.2c0.7-2.1,0.5-3.8-0.5-4.8l0,0C41.3,0.4,40,0.1,38.4,0.4z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M33.8,33.5c0,0-0.6-1.9,0.3-3.4c0.9-1.6,2.4-3.8,1-8.6c0,0,0.2-0.6-2.6-3.8c0,0-1.4-1.7-3.4-3.6 s-8.6-5.6-13.8-1.6c-5.2,4-1.3,11.8,0.1,13.8c0,0,1.3,2.2,3,3.9c1.7,1.7,3.9,3,3.9,3s3.1,1.7,9-0.1C31.2,33.1,32.3,32.7,33.8,33.5z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M35.1,21.5c0.4,1.2,0.5,2.1,0.5,3c0,1.4-9,9.6-10.4,9.5c-2-0.1-3-0.7-3-0.7L35.1,21.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M20.3,31.9c-0.6-0.5-1.3-1-1.9-1.7l14.1-12.5c0.7,0.8,1.2,1.4,1.6,1.9L20.3,31.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M30.9,16c-0.5-0.6-1.2-1.2-1.9-1.9L15.4,26.3c0,0,0.7,1.1,1.7,2.4L30.9,16z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 15.4,
  cy: 17.7,
  r: 1.1
}), /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 19.8,
  cy: 13.8,
  r: 1.1
}));

function SvgIcnApe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.6 40.5",
    style: {
      enableBackground: "new 0 0 43.6 40.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnApe);
export default __webpack_public_path__ + "static/media/icn_ape.418160e1.svg";
export { ForwardRef as ReactComponent };